import MAffix from './Affix.vue';

export default MAffix;
